export default __webpack_public_path__ + "static/media/mysql.b4863075.png";